import React from 'react';
import { useExpiredEffectiveDateStore } from 'src/store/expired-effective-date';
import { format, parseISO } from 'date-fns';
import { Modal } from '../Modal';
import './AcceptanceWarningModal.scss';

export const ExpiredEffectiveDateModal: React.FC = () => {
  const {
    isModalOpen,
    clearExpiredEffectiveDate,
    expiredEffectiveDate,
    isProcessing,
    error,
  } = useExpiredEffectiveDateStore();

  const handleConfirm = async () => {
    try {
      await clearExpiredEffectiveDate();
    } catch (err) {
      // Error is handled in the store
    }
  };

  const handleClose = () => {
    // Don't allow closing without confirming - user must choose a new effective date
  };

  if (!isModalOpen) return null;

  const formattedDate = expiredEffectiveDate
    ? format(parseISO(expiredEffectiveDate), 'MMMM d, yyyy')
    : '';

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleClose}
      className="acceptance-warning-modal"
      hideCloseButton={true}
      blockOverlayClick={true}
    >
      <div className="acceptance-warning">
        <div className="acceptance-warning__image">
          <img
            src="/images/modalUnderReview.jpg"
            alt="Effective date expired"
            className="acceptance-warning__image-content"
          />
        </div>

        <div className="acceptance-warning__content">
          <div className="acceptance-warning__text">
            <p className="acceptance-warning__paragraph">
              Sorry, but your previously selected effective date for coverage (
              <strong>{formattedDate}</strong>) is no longer available because
              you didn't complete payment.
            </p>
            <p className="acceptance-warning__paragraph">
              You will need to choose a new effective date to continue.
            </p>
          </div>

          {error && (
            <p
              className="acceptance-warning__error"
              style={{ color: 'red', marginBottom: '16px' }}
            >
              {error}
            </p>
          )}

          <div className="acceptance-warning__actions">
            <button
              className="acceptance-warning__button acceptance-warning__button--proceed"
              onClick={handleConfirm}
              disabled={isProcessing}
            >
              {isProcessing ? 'Processing...' : 'Confirm'}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
